import { render, staticRenderFns } from "./BasicUsageDemo.vue?vue&type=template&id=19491608&scoped=true"
import script from "./BasicUsageDemo.vue?vue&type=script&lang=js"
export * from "./BasicUsageDemo.vue?vue&type=script&lang=js"
import style0 from "./BasicUsageDemo.vue?vue&type=style&index=0&id=19491608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19491608",
  null
  
)

export default component.exports